import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';
import { swiperOnResize } from '../../utils/swiperOnResize.utils.js';

let talentExpertiseSwiperWr = document.querySelectorAll('.talent-expertise-swiper-wr');
talentExpertiseSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    swiperOnResize('(max-width: 841px)', swiperEl,
        {
          modules: [Autoplay, Navigation],
          slidesPerView: 1.05,
          spaceBetween: 12,
          speed: 600,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
          breakpoints: {
            640: {
              slidesPerView: 1.3,
              spaceBetween: 16,
            },
            767: {
              slidesPerView: 1.5,
              spaceBetween: 18,
            },
          },
          navigation: {
            prevEl: prevEl,
            nextEl: nextEl,
          },
        },
    );
  }
});